var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import styled from "styled-components";
import authentication from "@irati/auth";
import { ContextRoute, Bundle } from "@irati/utils/history/routing";
import RegionProvider from "@irati/region/components/Provider";
import { FormattedMessage } from "@irati/utils/lang";
import Loading from "@irati/ui/src/Loading";
import Admin from "@irati-web/admin";
import Perks from "@irati-web/perks";
import PerksAccount from "@irati-web/account";
import Platform from "@irati-web/platform/src/routes/tenant";
import Public from "@irati-web/platform/src/routes/public";
import Recognition from "@irati-web/recognition";
import Insights from "@irati-web/insights";
import Survey from "@irati-web/survey";
import Search from "@irati-web/search";
import SetupTenant from "@irati-web/tenantsetup";
import Onboarding from "@irati-web/onboarding";
import Medical from "@irati-web/medical";
import Wallet from "@irati-web/wallet";
import Home from "@irati-web/home";
import MFAPopup from "@irati-web/mfa/components/MFAPopup";
import AuthStream from "@irati/auth/streams/auth";
import UnauthedStream from "@irati/auth/streams/unauthed";
import APPS, { ACCOUNT, ADMIN, PERKS, PLATFORM, PUBLIC, RECOGNITION, INSIGHTS, SURVEY, SEARCH, SETUP_TENANT, ONBOARDING, MEDICAL, WALLET, HOME } from "../routeConfig";
import Providers from "../Providers";
import AuthProvider from "../AuthProvider";
var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 100px 30px;\n  text-align: center;\n"], ["\n  padding: 100px 30px;\n  text-align: center;\n"])));
var TenantSubdomainNotFound = function () { return (React.createElement(StyledDiv, null,
    React.createElement(FormattedMessage, { id: "errors.tenant.subdomain" }))); };
var InternalRoutes = /** @class */ (function (_super) {
    __extends(InternalRoutes, _super);
    function InternalRoutes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDefaultPath = function () {
            var _a = authentication.apps(), perks = _a.perks, recognition = _a.recognition, insights = _a.insights, medical = _a.medical, admin = _a.admin;
            if (perks || recognition || insights || medical || admin) {
                return APPS.HOME;
            }
            return APPS.PUBLIC;
        };
        return _this;
    }
    InternalRoutes.prototype.render = function () {
        return (React.createElement(Providers, null,
            React.createElement(RegionProvider, { useSubdomain: true }, function (_a) {
                var load = _a.load;
                return (React.createElement(Loading, { load: load, Error: TenantSubdomainNotFound },
                    React.createElement(AuthProvider, { authed: AuthStream, unauthed: UnauthedStream },
                        React.createElement(Bundle, null,
                            React.createElement(ContextRoute, { app: PLATFORM, apps: APPS, routes: Platform }),
                            React.createElement(ContextRoute, { app: ADMIN, apps: APPS, routes: Admin }),
                            React.createElement(ContextRoute, { app: PERKS, apps: APPS, routes: Perks }),
                            React.createElement(ContextRoute, { app: ACCOUNT, apps: APPS, routes: PerksAccount }),
                            React.createElement(ContextRoute, { app: RECOGNITION, apps: APPS, routes: Recognition }),
                            React.createElement(ContextRoute, { app: INSIGHTS, apps: APPS, routes: Insights }),
                            React.createElement(ContextRoute, { app: SURVEY, apps: APPS, routes: Survey }),
                            React.createElement(ContextRoute, { app: SEARCH, apps: APPS, routes: Search }),
                            React.createElement(ContextRoute, { app: ONBOARDING, apps: APPS, routes: Onboarding }),
                            React.createElement(ContextRoute, { app: PUBLIC, apps: APPS, routes: Public }),
                            React.createElement(ContextRoute, { app: WALLET, apps: APPS, routes: Wallet }),
                            React.createElement(ContextRoute, { app: MEDICAL, apps: APPS, routes: Medical }),
                            React.createElement(ContextRoute, { app: HOME, apps: APPS, routes: Home }),
                            React.createElement(ContextRoute, { app: SETUP_TENANT, apps: APPS, routes: SetupTenant }),
                            React.createElement(Route, { exact: true, path: "/", component: function (_a) {
                                    var location = _a.location;
                                    return React.createElement(Redirect, { to: __assign(__assign({}, location), { pathname: APPS.HOME }) });
                                } }),
                            React.createElement(MFAPopup, null)))));
            })));
    };
    return InternalRoutes;
}(Component));
export default InternalRoutes;
var templateObject_1;
